import React                                from "react";
import Style                                from "../UI/main.module.scss";
import { GetSystemLabel }                   from "Utilities/utils";

export const ModalContent              = React.memo(({...Content})     => {    
    const {Message, ClickAction} = Content;
    return (
        <div>
            <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                    <div className={[Style.p_5].join(" ")}>
                        <span className={[Style.text_body, Style.fs_8].join(" ")}>
                            {Message}
                        </span>
                    </div>
                </div>
            </div>
            {ClickAction ? <div className={[Style.p_5].join(" ")}>{ClickAction}</div> : null }        
        </div>
    );
});
export const ModalContentGoAction      = ({...Content}) => {
    const {Message, Action } = Content;
    return (
        <ModalContent 
            Message={Message}
            ClickAction={
                <div className={Style.row}>
                    <div className={Style.col_lg_9}/>
                    <div className={[Style.col_lg_3].join(" ")}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.clickable,
                                            Style.vanilla_bg, 
                                            Style.rounded_3, 
                                            Style.border, 
                                            Style.shadow_sm, 
                                            Style.py_3,
                                            Style.px_5,
                                            Style.pop_item_animation,
                                            Style.m_3].join(" ")}                                    
                                onClick={async () => {
                                    await Action();
                                }}
                        >
                            <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                {GetSystemLabel("Proceed")}
                            </span>                                
                        </div>
                    </div>

                </div>
            }
        />
    );
};     